import React from 'react';

interface Icon3DMobileDevProps {
  size?: string;
}

const Icon3DMobileDev: React.FC<Icon3DMobileDevProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'wobble-mobile 2.5s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{ filter: 'drop-shadow(0 2px 8px rgba(139, 92, 246, 0.3))' }}
        >
          <defs>
            <linearGradient id="mobiledevGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8b5cf6" />
              <stop offset="50%" stopColor="#a78bfa" />
              <stop offset="100%" stopColor="#7c3aed" />
            </linearGradient>
          </defs>
          <rect x="5" y="2" width="14" height="20" rx="2" fill="url(#mobiledevGradient)" opacity="0.2" stroke="url(#mobiledevGradient)" strokeWidth="1.5" />
          <rect x="6" y="3" width="12" height="15" rx="1" fill="url(#mobiledevGradient)" opacity="0.3" />
          <circle cx="12" cy="20" r="1" fill="url(#mobiledevGradient)" />
          <line x1="8" y1="6" x2="16" y2="6" stroke="url(#mobiledevGradient)" strokeWidth="1" opacity="0.7" />
        </svg>
        <style>{`
          @keyframes wobble-mobile {
            0%, 100% { transform: rotateZ(0deg) rotateY(0deg); }
            25% { transform: rotateZ(-3deg) rotateY(5deg); }
            75% { transform: rotateZ(3deg) rotateY(-5deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DMobileDev;
